export default {"src":"/_next/static/media/minus.05958027.svg","height":2,"width":12,"blurWidth":0,"blurHeight":0};